import { BRAND } from '../../config/brand';
import './Legal.css';

function LegalPrivacy() {
  return (
    <main className="legal-page">
      <div className="container">
        <div className="legal-card">
          <h1 className="legal-title">Privacy Policy</h1>
          <div className="legal-meta">
            Last updated: {BRAND.legal.lastUpdated} • {BRAND.legal.companyName}
          </div>

          <div className="legal-content">
            <p>
              This Privacy Policy explains how <strong>{BRAND.legal.companyName}</strong> collects and uses information when
              you use our website and purchase our services.
            </p>

            <h2>1) Information We Collect</h2>
            <ul>
              <li>Contact information you provide (e.g., email, name).</li>
              <li>Order details (selected domain, price, timestamps).</li>
              <li>Payment confirmation identifiers from PayPal (we do not store your full payment card details).</li>
              <li>Basic technical data (e.g., IP address, browser) for security and fraud prevention.</li>
            </ul>

            <h2>2) How We Use Information</h2>
            <ul>
              <li>To process and fulfill your domain purchase.</li>
              <li>To provide support and communicate about your order.</li>
              <li>To detect and prevent fraud/abuse and to secure our systems.</li>
            </ul>

            <h2>3) Payments (PayPal)</h2>
            <p>
              Payments are processed by PayPal. PayPal’s processing is subject to PayPal’s own privacy policy and terms.
            </p>

            <h2>4) Data Sharing</h2>
            <p>
              We share data only as needed to process payments, deliver service, comply with law, or protect our rights.
            </p>

            <h2>5) Data Retention</h2>
            <p>
              We retain order records for as long as needed to fulfill orders, support customers, and meet legal or accounting
              requirements.
            </p>

            <h2>6) Your Choices</h2>
            <p>
              You can contact us to request access, correction, or deletion of your personal data where applicable.
            </p>

            <h2>7) Contact</h2>
            <p>
              Privacy questions: <a className="legal-link" href={`mailto:${BRAND.legal.contactEmail}`}>{BRAND.legal.contactEmail}</a>
            </p>

            <h2>8) Legal Review Note</h2>
            <p>
              This document is a general template and should be reviewed by legal counsel to match your jurisdiction and
              operational details.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default LegalPrivacy;
